module.exports = __webpack_public_path__ + "media/bootstrap-icons/reply-all-ae953197.svg";